export const fmt = (v) => `£${Number(v || 0).toFixed(2)}`;

export const todayStr = () => new Date().toISOString().split('T')[0];

export const calcTotals = (items, delivery = 0) => {
  const subtotal = items.reduce((s, it) => s + (Number(it.qty) * Number(it.unitPrice) || 0), 0);
  const vatAmount = items.reduce((s, it) => {
    const l = Number(it.qty) * Number(it.unitPrice) || 0;
    return s + (Number(it.vatRate) === 20 ? l * 0.2 : 0);
  }, 0);
  const grandTotal = subtotal + vatAmount + Number(delivery || 0);
  return {
    subtotal: +subtotal.toFixed(2),
    vatAmount: +vatAmount.toFixed(2),
    grandTotal: +grandTotal.toFixed(2),
  };
};
